import { select } from "redux-saga/effects";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import { getCurrentUserId } from "@app/store/iam";
import { getTeams } from "@app/store/members";
import Scope from "@app/types/dashboard/Scope";

// A team board carries no userId, so the team's members have to be resolved before filtering.
export function* resolveScopedUserIds(
  scope?: Scope
): Generator<unknown, { isOwnUserScope: boolean; userIds: User["id"][] }, never> {
  const isTeamScope = !!scope?.teamId && !scope?.userId;
  const teams: Team[] = yield select(getTeams);

  let userIds: User["id"][] = scope?.userId ? [scope.userId] : [];
  if (isTeamScope) {
    userIds = teams.find(({ id }) => id === scope?.teamId)?.users.map(({ id }) => id) ?? [];
  }

  const isUserScope = !scope?.teamId && !!scope?.userId;
  const currentUserId: User["id"] = yield select(getCurrentUserId);

  return { isOwnUserScope: isUserScope && currentUserId === scope?.userId, userIds };
}

export default resolveScopedUserIds;
